import { render } from "./Sewing.vue?vue&type=template&id=a59bd19a"
import script from "./Sewing.vue?vue&type=script&lang=js"
export * from "./Sewing.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__